import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography, Stack } from "@mui/material";
import "./GraphCard.scss";

const data = [
  { name: "Gen", 2023: 40, 2024: 70 },
  { name: "Feb", 2023: 60, 2024: 90 },
  { name: "Mar", 2023: 30, 2024: 60 },
  { name: "Apr", 2023: 40, 2024: 70 },
  { name: "Mag", 2023: 30, 2024: 60 },
  { name: "Giu", 2023: 10, 2024: 50 },
  { name: "Lu", 2023: 80, 2024: 100 },
];

const Graph = () => {
  const CustomizedXAxisTick = ({ x, y, payload }) => {
    // Change "#FF0000" to any color you want
    const customColor = "#919EAB";
    return (
      <text x={x} y={y + 10} fill={customColor} textAnchor="middle"  fontSize={12}>
        {payload.value}
      </text>
    );
  };
  const CustomizedYAxisTick = ({ x, y, payload }) => {
    // Change "#FF0000" to any color you want
    const customColor = "#919EAB";
    return (
      <text
        x={x - 10} // adjust horizontal position as needed
        y={y}
        dy={4}
        fill={customColor}
        textAnchor="end"
        fontSize={12}
      >
        {payload.value}
      </text>
    );
  };
  return (
    <Box className="graphCard">
      <Typography className="title" variant="h3" gutterBottom>
        Produzione
      </Typography>
      <Typography className="subTitle" variant="body2" gutterBottom>
        (+43%) Nell'ultimo anno
      </Typography>

      {/* Year Legend at Top Right */}
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: "#0F8F82",
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">2023</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: "#FDCB57",
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">2024</Typography>
        </Box>
      </Stack>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tickMargin={10}
            tick={<CustomizedXAxisTick />}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            ticks={[0, 20, 40, 60, 80, 100]}
            tick={<CustomizedYAxisTick />}
          />
          <Tooltip cursor={false} />
          <Bar
            dataKey="2023"
            fill="#0F8F82"
            barSize={20}
            radius={[6, 6, 0, 0]}
          />
          <Bar
            dataKey="2024"
            fill="#FDCB57"
            barSize={20}
            radius={[6, 6, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default Graph;
